import React, { Component } from "react";
import "styled-components/macro";

import guessMyDevice from "./utils/guess-my-device";

export default class CardRSSSource extends Component {

  device = guessMyDevice()

  render() {
    const { imgSrc, name, url, imgWidth, imgHeight } = this.props;
    return (
      <div
        css={`
          display: flex;
          justify-content: space-around;
          width: calc(${this.device !== 'mobile' ? '20% - 25.8px' : '104px - 25px'});
          height: ${this.device !== 'mobile' ? '100px' : '85px'};
          padding: ${this.device !== 'mobile' ? '31px 0 31px 23px' : '15px 10px 15px 15px'};
          flex-direction: column;
          align-items: flex-start;
          gap: 5px;
          flex-shrink: 0;
          border: 1px solid rgba(236, 236, 240, 0);
          background: #ffffff;
        `}
      >
        <div>
          <img
            src={imgSrc}
            css={`
              width: ${imgWidth}px;
              height: ${imgHeight}px;
          `}
          />
        </div>

        <div
          css={`width: 100%;`}
        ><div
          css={`
            width: 100%;
            font-size: ${this.device !== "mobile"
              ? '18px'
              : '14px'};
            font-weight: 500;
            color: #02021d;
          `}
        >
            {name}
          </div>
          <div
            css={`
            /* width: 100%; */
            margin: 3px 0 0;
            padding: 0 20px 0 0;
            font-size: ${this.device !== "mobile"
                ? '14px'
                : '10px'};
            color: #afafbf;
            text-overflow: ellipsis;
            overflow: hidden;
          `}
          >
            {url}
          </div></div>
      </div>
    );
  }
}
